import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './app'

import { initI18N } from '../../i18next';

initI18N().then(() => {
    const root = createRoot(document.getElementById('order-status-app'));
    root.render(<App />);
});
